import { elements, showClassName } from './modules/lib';
import { showErrorToast, showSuccessToast } from './modules/toast';

// Open menu with several sharing options
elements.toggle().forEach((el) => {
	el.addEventListener('focus', () => {
		el.classList.add(showClassName);
	});
});

// Copy URL functionality
elements.copy().forEach((el) => {
	el.addEventListener('click', async () => {
		//! Temporary fix for Google Chrome on Windows
		const browser = navigator.userAgentData?.brands[0].brand;
		const os = navigator.userAgentData?.platform;
		const windowsChrome = 'Windows' === os && 'Google Chrome' === browser;

		if (!windowsChrome && navigator.canShare && navigator.canShare({ url: window.location.href, title: document.title, text: document.title })) {
			try {
				await navigator.share({
					title: document.title,
					text: document.title,
					url: window.location.href,
				});
			} catch (error) {
				console.error('Error sharing content:', error);
				copyToClipboard();
			}
		} else if (navigator.clipboard) {
			copyToClipboard();
		}
	});
});

const copyToClipboard = () => {
	if (navigator.clipboard) {
		return navigator.clipboard.writeText(window.location.href).then(showSuccessToast, showErrorToast);
	} else {
		console.error('Clipboard API not available');
	}
};

// Print button
elements.print().forEach((el) => {
	el.addEventListener('click', () => {
		window.print();
	});
});
